import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import CoursesPage from "./Courses/CoursesPage";
import StepPage from "./Steps/StepPage";
import CourseCobrandSettingsRouter from "./CobrandSettings/CourseCobrandSettingsRouter";

const CoursesFeaturePage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/courses`}>
                <CoursesPage />
            </Route>
            <Route path={`${path}/steps`}>
                <StepPage />
            </Route>
            <Route path={`${path}/cobrand-settings`}>
                <CourseCobrandSettingsRouter />
            </Route>
        </div>
    );
};

export default CoursesFeaturePage;
